import { render } from "./ARScene.vue?vue&type=template&id=b0ce9d5e&scoped=true"
import script from "./ARScene.vue?vue&type=script&lang=js"
export * from "./ARScene.vue?vue&type=script&lang=js"

import "./ARScene.vue?vue&type=style&index=0&id=b0ce9d5e&scoped=true&lang=css"

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ce9d5e"]])

export default __exports__